import { SettingsPanelValidationError } from '@workbuddy/ui/v2/blocks/settings.panel';

export function nameRequired(values: Record<string, unknown>): SettingsPanelValidationError[] | null {

  return String(values['name'] ?? '').trim()
    ? null
    : [{ field: 'name', required: true }];
}
